import { ReactElement } from 'react'
import { Navigate } from 'react-router'

import { useOrganizationSource } from '../../../../hooks'
import { SettingsRoute } from '../../enums/settingsRoute'
import { CardPaymentsContent } from './elements/CardPaymentsContent'

export const OrganizationCardPaymentsSettings = (): ReactElement | null => {
  const { isSourceBilly, isSourceZervant } = useOrganizationSource()

  // Card payments only exist for the Zervant invoicing solution. Access is gated by the invoicing
  // scope on the route, so source only decides what to render.
  if (isSourceZervant) {
    return <CardPaymentsContent />
  }

  if (isSourceBilly) {
    return <Navigate to={SettingsRoute.Organization} replace />
  }

  return null
}
